//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBobAccountController_findAll,
  Response$AdminBobAccountController_findAll$Status$200,
  ResponseContentType$AdminBobAccountController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminBobAccountController_findAll = (options: {
  params: Params$AdminBobAccountController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminBobAccountController_findAll$Status$200[ResponseContentType$AdminBobAccountController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminBobAccountController_findAll,
    Response$AdminBobAccountController_findAll$Status$200[ResponseContentType$AdminBobAccountController_findAll]
  >({
    method: 'AdminBobAccountController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
